import React from 'react';

import { IFormHandleExtended } from '../../../../components/FormQuiz';
import { ParticipantStep } from '../../../../../../../types/v3Types';
import { FormError } from '@wix/form-viewer/widget';

export interface ISidebarLayoutBaseContext {
  formQuizRef: React.RefObject<IFormHandleExtended>; // we need it to have a way to submit a form from btn located in a sibling component
  formValidity: FormError[];
  setFormValidity: (formValidity: FormError[]) => void;
  currentStep: ParticipantStep;
  isCurrentStepHidden: boolean;
  goToCurrentStep(): void;
  pageRef: React.RefObject<HTMLElement>;
  videoStepAccepted: boolean;
  setVideoStepAccepted(videoStepAccepted: boolean): void;
  isVideoLoadingError: boolean;
  setIsVideoLoadingError(isError: boolean): void;
  resolveCurrentStep(): Promise<void>;
  isAutoPlayVideo: boolean;
  changeAutoplayOptions(isAutoplayEnabled: boolean): Promise<void>;
  checkAutoNavigate(): Promise<void>;
  isSidebarCollapsed: boolean;
  isCollapsibleSidebarEnabled: boolean;
  toggleSidebarCollapse: () => void;
  isAiChatVisible: boolean;
  isAiChatEnabled: boolean;
  toggleAiChatVisibility: () => void;
}

export const SidebarLayoutBaseContext =
  React.createContext<ISidebarLayoutBaseContext>({
    formQuizRef: null,
    formValidity: null,
    setFormValidity: () => {},
    currentStep: null,
    isCurrentStepHidden: false,
    goToCurrentStep: () => {},
    pageRef: null,
    videoStepAccepted: false,
    setVideoStepAccepted: () => {},
    isVideoLoadingError: false,
    setIsVideoLoadingError: () => {},
    resolveCurrentStep: async () => {},
    isAutoPlayVideo: false,
    changeAutoplayOptions: async () => {},
    checkAutoNavigate: async () => {},
    isSidebarCollapsed: false,
    isCollapsibleSidebarEnabled: false,
    toggleSidebarCollapse: () => {},
    isAiChatVisible: false,
    isAiChatEnabled: false,
    toggleAiChatVisibility: () => {},
  });

export function useSidebarLayoutBase(): ISidebarLayoutBaseContext {
  return React.useContext(SidebarLayoutBaseContext);
}
